export default {"src":"/_next/static/media/VE_SELLER.dd519220.svg","height":24,"width":134,"blurWidth":0,"blurHeight":0};